// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2p5Pg","item":"PaymentsMobile_item__14_mK","label":"PaymentsMobile_label__cYVJT","amount":"PaymentsMobile_amount__2EViD"};